import React, { memo } from "react";
import { Link } from "../../utils/link";

const Announcement = ({ title, description, buttonText, buttonLink }) => {
  return (
    <div className="flex flex-col px-[10px] md:px-[25px] h-full items-start">
      <h2 className="text-[25px] tracking-wide leading-[38px] font-bold">
        {title}
      </h2>
      <p className="text-base tracking-wide leading-7 mt-5 min-h-[80px] mb-1 font-normal">
        {description.description}
      </p>
      {buttonText && buttonLink && (
        <Link
          to={buttonLink}
          className="border-2 border-solid border-white text-white text-center bg-transparent py-3 px-9 hover:scale-105 hover:underline 
        hover:underline-offset-[6px] transition-transform duration-150 ease-linear rounded-full"
        >
          {buttonText}
        </Link>
      )}
    </div>
  );
};

export default memo(Announcement);
